import { cleanObject } from '@shared/utils';

const createRequestFailure = ({ code = undefined, message = 'Request failed', status = undefined, detail = undefined, data = undefined } = {}) => {
  const safeMessage = String(message || 'Request failed').trim() || 'Request failed';
  const safeCode = code === undefined || code === null ? '' : String(code).trim();

  return cleanObject(
    {
      success: false,
      code: safeCode || undefined,
      message: safeMessage,
      status,
      detail,
      data
    },
    { strict: true }
  );
};

export default createRequestFailure;
